export var WEPIN_DEFAULT_LANG="en";export var WEPIN_DEFAULT_CURRENCY="usd";